// extracted by mini-css-extract-plugin
export default {"wrapper":"BannerComponent_wrapper__WRN-A"};